export async function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch('/api/data', { 
    method: 'POST', 
    credentials: 'include',
    body: formData 
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Authentication required');
    }
    throw new Error(await res.text());
  }

  const data = await response.json()
  return data
}


export async function downloadFile(dataId, partId) {
  if (!dataId) {
    return null
  }
  
  let resourceUrl = String(dataId)
  if (partId) {
    resourceUrl = String(dataId) + '/' + String(partId)
  }

  const thumbnail = await fetch("/api/data/" + resourceUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  })

  return URL.createObjectURL(await thumbnail.blob())
}


export async function processMessage(currentSessionId, inputDataId, inputAuxDataId, message) {
  const response = await fetch("/api/esper/session/" + String(currentSessionId) + "/chat", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      message: message,
      input_data_id: inputDataId,
      input_aux_data_id: inputAuxDataId,
    })
  })

  const data = await response.json()
  console.log('Received message', data)

  const taskResponse = await fetch("/api/task/" + String(data.last_task), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  })

  const taskResult = await taskResponse.json()
  console.log('Received taskResult', taskResult)
  
  return {message: data, task: taskResult}
}

// Audio transcription API
export async function transcribeAudio(audioBlob, language = null) {
  console.log('🎤 Sending audio for transcription...');
  console.log('📊 Audio blob size:', audioBlob.size, 'bytes');
  console.log('📊 Audio blob type:', audioBlob.type);
  
  const formData = new FormData();
  
  // Always use WAV for better compatibility
  const filename = 'recording.wav';
  
  formData.append('audio', audioBlob, filename);
  if (language) {
    formData.append('language', language);
  }
  
  console.log('📡 Sending request to /transcribe...');
  const res = await fetch('/api/esper/audio/transcribe', { 
    method: 'POST', 
    body: formData 
  });
  
  console.log('📡 Response status:', res.status);
  console.log('📡 Response ok:', res.ok);
  
  if (!res.ok) {
    const errorText = await res.text();
    console.error('❌ Transcription request failed:', errorText);
    throw new Error(errorText);
  }
  
  const result = await res.json();
  console.log('✅ Transcription response:', result);
  return result;
}

export async function getAudioHealth() {
  const res = await fetch('/api/esper/audio/audio/health');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getSupportedLanguages() {
  const res = await fetch('/api/esper/audio/audio/languages');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// User sessions API
export async function getUserSessions() {
  const res = await fetch('/api/user/sessions');
  if (!res.ok) {
    if (res.status === 401) {
      throw new Error('Authentication required');
    }
    throw new Error(await res.text());
  }
  return res.json();
}